"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ErrorBanner_1 = __importDefault(require("./ErrorBanner"));
exports.default = ErrorBanner_1.default;
//# sourceMappingURL=index.js.map